import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import keydown from 'react-keydown';

import { Box, Flex } from 'rebass';
import { Link, Text } from '../../../../Components/Base';
import BaseIcon from '../../../../Components/Base/Icon';

const Icon = props => <BaseIcon fontSize="1.4em" {...props} />;

const SolutionToolbarView = ({
  onBackClick,
  onNextClick,
  onPreviousClick,
  disableNextButton,
  disablePreviousButton,
}) => (
  <Flex justifyContent="space-between" mb={2} px={2}>
    <Link onClick={onBackClick} color="white">
      <Icon name="keyboard_backspace" mr={2} />
      ข้อทั้งหมด
    </Link>
    <Flex>
      <Link onClick={onPreviousClick} disabled={disablePreviousButton} color="white" mr={3}>
        <Icon name="chevron_left" />
        ข้อก่อนหน้า
      </Link>
      <Link onClick={onNextClick} disabled={disableNextButton} color="white">
        ข้อถัดไป
        <Icon name="chevron_right" />
      </Link>
    </Flex>
  </Flex>
);

class SolutionToolbar extends Component {
  static propTypes = {
    onNavigateKeyPressed: PropTypes.func,
  };

  static defaultProps = {
    onNavigateKeyPressed: () => {},
  };

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.keydown.event && prevProps.keydown.event) {
      const { event } = prevProps.keydown;
      this.props.onNavigateKeyPressed(event);
    }
  }

  render() {
    return <SolutionToolbarView {...this.props} />;
  }
}

export default keydown('left', 'right')(SolutionToolbar);
